import { useQuery } from "react-query";
import { getOfficeBanks } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeBanks = () => {
  return useQuery("GetOfficebanks", getOfficeBanks, {
    refetchOnWindowFocus: false,
  });
};
